import { AppLayout } from "@/components/app-layout/AppLayout";
import { AppSidebar } from "@/components/app-layout/AppSidebar";
import { AppTopBar } from "@/components/app-layout/AppTopBar";
import { KitMenu } from "@/components/app-layout/menus/kit/KitMenu";
import { Outlet } from "@tanstack/react-router";

export default function KitLayout() {
  return (
    <AppLayout>
      <AppSidebar.ContentPortal>
        <KitMenu mode="sidebar" />
      </AppSidebar.ContentPortal>
      <AppTopBar.ContentPortal>
        <KitMenu mode="topbar" />
      </AppTopBar.ContentPortal>
      <Outlet />
    </AppLayout>
  );
}
